import { BaseDropdown } from './component/BaseDropdown';
import { useDropdownOptions } from '../../hooks/useDropdownOptions';
import { BusinessDropdownProps } from './component/type';

const COLUMN_NAMES: string[] = ['Code', 'Description'];

export const VatHandlingCodesDropdown = (props: BusinessDropdownProps) => {
  const shouldPreventApiCall = props.disabled || props.readOnly;

  const { options: vatHandlingCodeOptions, loading } = useDropdownOptions({
    apiId: 'internal.v1.base-tables',
    operationId: 'GET /promptValues/{windowId}',
    labelAttribute: 'description',
    valueAttribute: 'vatHandlingCode',
    params: { windowId: 'vatHandlingCodes' },
    shouldPreventApiCall,
  });

  return <BaseDropdown {...props} loading={loading} options={vatHandlingCodeOptions} columnNames={COLUMN_NAMES} />;
};
